<template>
  <div id="app">
    <div id="nav">
      <h1>
        🍺
      </h1>
      <div>
        <div v-if="token">
          {{ user.name }}, <router-link to="/signout">Signout</router-link>
        </div>
        <div v-if="!token">
          <router-link to="/signup">Signup</router-link> |
          <router-link to="/signin">Signin</router-link>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapState("user", ["user", "token"]),
  },
  // beforeCreate() {
  //   this.$store.dispatch("user/initState");
  // }
};
</script>
<style lang="scss">
h1,
h2,
h3,
h4,
h5,
h6 {
  color: white;
}
body {
  background: #252525;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #cccccc;
}

#nav {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e3e3e3;
  h1 {
    margin: 0;
    font-weight: bold;
  }
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
body {
  margin: 0;
}
</style>
